"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineConfigPGADescriptions = void 0;
const convertTimeFormat_1 = require("../convertTimeFormat");
const currencyFormatter_1 = require("../currencyFormatter");
const pluralize_1 = require("../pluralize");
const groupRoomsByTypeAndBoard_1 = require("./groupRoomsByTypeAndBoard");
const getOrderLineConfigPGADescriptions = (data, type) => {
    if (!data || !type)
        return null;
    const descriptions = [];
    switch (type) {
        case "GOLF": {
            const config = data;
            const hasPayAtCourseExtras = () => {
                if (config?.caddies?.enabled &&
                    config?.caddies?.payment_option === "ON_ARRIVAL") {
                    return true;
                }
                if (config?.carts?.enabled &&
                    config?.carts?.payment_option === "ON_ARRIVAL") {
                    return true;
                }
                return false;
            };
            const payAtCourseExtras = () => {
                if (!hasPayAtCourseExtras()) {
                    return ``;
                }
                const payAtCourse = [];
                if (config?.caddies?.enabled &&
                    config?.caddies?.payment_option === "ON_ARRIVAL") {
                    payAtCourse.push(`${config.caddies?.quantity} x ${config?.caddies?.type === "SINGLE_CADDIE"
                        ? "single caddie"
                        : "shared caddies"}
            (${(0, currencyFormatter_1.currencyFormatter)(config?.supplier?.currency, config?.caddies?.total || 0, false)})`);
                }
                if (config?.carts?.enabled &&
                    config?.carts?.payment_option === "ON_ARRIVAL") {
                    config?.carts?.types &&
                        config?.carts?.types.map((type) => {
                            if (type.quantity === 0)
                                return null;
                            payAtCourse.push(`${type.quantity} x ${type.type === "SINGLE_CART" ? "single cart" : "shared cart"}
              (${(0, currencyFormatter_1.currencyFormatter)(config?.supplier?.currency, type.total, false)})`);
                        });
                }
                return `Pay at course: ${payAtCourse.join(" + ")}`;
            };
            let start_times = "";
            if (config.tee_time &&
                config.tee_time.start_time &&
                config.tee_time.end_time) {
                if (config.tee_time.start_time !== config.tee_time.end_time) {
                    start_times = `Tee off between ${(0, convertTimeFormat_1.convertTimeFormat)(config.tee_time.start_time)} and ${(0, convertTimeFormat_1.convertTimeFormat)(config.tee_time.end_time)}`;
                }
                else {
                    start_times = `Tee off at ${(0, convertTimeFormat_1.convertTimeFormat)(config.tee_time.start_time)} (shotgun start)`;
                }
            }
            descriptions.push(`${config?.tee_time?.start_time ? `${start_times}` : ``}${config.hole_options?.selected_option &&
                config.hole_options?.hole_options?.length > 0
                ? ` (${config.hole_options?.selected_option === "ANY"
                    ? "No Course Preference"
                    : config.hole_options?.hole_options.find((x) => x.id === config.hole_options?.selected_option)?.description || "Unknown Course"})`
                : ""}`);
            if (payAtCourseExtras() !== "")
                descriptions.push(`${payAtCourseExtras()}`);
            const optionalExtras = () => {
                const optional = [];
                if (config?.green_fee?.cart_policy === "optional" &&
                    !config?.carts?.enabled &&
                    !config.product.config?.single_cart &&
                    !config.product.config?.shared_cart) {
                    config?.carts?.types &&
                        config?.carts?.types.map((type) => {
                            optional.push(`${type.type === "SINGLE_CART" ? "Single cart" : "Shared cart"} (${(0, currencyFormatter_1.currencyFormatter)(config?.supplier?.currency, type.cost_per_cart, false)})`);
                        });
                }
                if (config?.green_fee?.caddie_policy === "optional" &&
                    !config?.caddies?.enabled &&
                    !config.product.config?.caddie &&
                    !config.product.config?.shared_caddie) {
                    optional.push(`${config?.caddies?.type === "SINGLE_CADDIE"
                        ? "Single caddie"
                        : "Shared caddies"} (${(0, currencyFormatter_1.currencyFormatter)(config?.supplier?.currency, (config?.caddies?.total || 0) / (config?.caddies?.quantity || 1), false)})`);
                }
                if (optional.length === 0)
                    return null;
                return `Optional Extras: ${optional.join(" + ")}`;
            };
            if (optionalExtras()) {
                descriptions.push(optionalExtras() || "");
            }
            // add the range balls
            break;
        }
        case "HOTEL": {
            const config = data;
            const grouped_rooms = (0, groupRoomsByTypeAndBoard_1.groupRoomsByTypeAndBoard)(config.rooms.rooms);
            grouped_rooms.forEach((room) => {
                let occupancy = room.occupancy;
                if (room.extra_beds > 0) {
                    occupancy += room.extra_beds;
                }
                descriptions.push(`${room.quantity} x ${room.name} ${room.extra_beds > 0
                    ? ` + ${(0, pluralize_1.pluralize)(room.extra_beds, "extra bed", "extra beds")}`
                    : ""} - ${(0, pluralize_1.pluralize)(occupancy, "guest", "guests")}`);
            });
            if (config.where_when_who.hotel.check_in_time) {
                descriptions.push(`Check-in from ${config.where_when_who.hotel.check_in_time}`);
            }
            // need to get all the unique warnings on the rates
            const warnings = new Set();
            config.rooms.rooms.forEach((room) => {
                room.rate.forEach((rate) => {
                    if (rate?.warnings) {
                        rate.warnings.forEach((warning) => {
                            warnings.add(warning);
                        });
                    }
                });
            });
            warnings.forEach((warning) => {
                descriptions.push(warning);
            });
            break;
        }
        case "EXCURSION": {
            const config = data;
            descriptions.push(`${config?.product?.variation?.name?.en} · ${config?.where_when_who.number_of_people} pax`);
            const d = [];
            if (config?.product?.variation?.start_time) {
                d.push(`Start time: ${config?.product?.variation?.start_time}`);
            }
            if (config?.product?.variation?.duration) {
                d.push(`Duration: ${config?.product?.variation?.duration}`);
            }
            // if (config?.product?.variation?.included_meals) {
            //   d.push(`Meals: ${config?.product?.variation?.included_meals}`);
            // }
            descriptions.push(d.join(" · "));
            descriptions.push(`${config?.product?.variation?.hotel_pickup_available
                ? "Includes"
                : "Excludes"} hotel pick-up/drop-off`);
            break;
        }
        case "TRANSFER": {
            const config = data;
            const getPickup = () => {
                switch (config?.transfer_legs?.outbound?.from_type) {
                    case "Hotel":
                    case "Airport": {
                        return `Pick-up time: ${config?.driver?.pickup_time || "TBC"}`;
                    }
                    case "Area": {
                        const area_config = config?.transfer_legs?.outbound
                            ?.from_details;
                        return `Pick-up address: ${area_config?.address || "TBC"} · Pick-up time: ${config?.driver?.pickup_time || "TBC"}`;
                    }
                    case "Course": {
                        return ``;
                    }
                    default: {
                        return "";
                    }
                }
            };
            descriptions.push(`${config?.vehicle?.vehicle?.id
                ? `${config?.vehicle?.quantity > 1
                    ? `${config?.vehicle?.quantity} x `
                    : ``}${config?.vehicle?.vehicle?.name?.en}`
                : `No Vehicle Selected`} · ${config?.where_when_who.number_of_passengers} passengers`);
            if (getPickup() !== "") {
                descriptions.push(getPickup());
            }
            break;
        }
        case "CUSTOM": {
            const config = data;
            config?.where_when_who?.product_description.forEach((description) => {
                descriptions.push(description.title);
            });
            break;
        }
    }
    return descriptions;
};
exports.getOrderLineConfigPGADescriptions = getOrderLineConfigPGADescriptions;
